import { createApp } from 'vue'
import { mountSearchFilterPopup } from './search-filter-mount'
import AdListApp from './pages/ad/AdListApp.vue'
import { upsertRecentSearch } from './recent-searches'

// 1. Vue Uygulamasını Başlat
document.addEventListener('DOMContentLoaded', () => {
    mountSearchFilterPopup();
    const el = document.getElementById('ad-list-vue')
    if (el && window.AD_LIST_CONFIG) {
        const app = createApp(AdListApp, { config: window.AD_LIST_CONFIG });
        app.mount(el);
    }
});

(function () {
    'use strict';

    // -------------------------
    // Helpers
    // -------------------------
    function $(id) { return document.getElementById(id); }
    function getConfig() { return window.AD_LIST_CONFIG || {}; }
    function csrfToken() { return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''; }
    function escapeHtml(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;'); }

    function i18n(path, fallback, vars) {
        var value = window.AD_LIST_I18N || {};
        String(path || '').split('.').forEach(function (part) {
            value = value && typeof value === 'object' ? value[part] : null;
        });
        var text = (typeof value === 'string' && value !== '') ? value : String(fallback || '');
        Object.keys(vars || {}).forEach(function (key) {
            text = text.split(':' + key).join(String(vars[key] == null ? '' : vars[key]));
        });
        return text;
    }


    function isGoogleMapsReady() {
        return !!(
            window.google &&
            window.google.maps &&
            typeof window.google.maps.Map === 'function' &&
            window.google.maps.marker &&
            typeof window.google.maps.marker.AdvancedMarkerElement === 'function'
        );
    }

    function waitForGoogleMaps(timeoutMs = 9000) {
        const cfg = getConfig();
        if (cfg.googleMapsKeyMissing) return Promise.resolve(false);
        if (isGoogleMapsReady()) return Promise.resolve(true);

        return new Promise((resolve) => {
            const startedAt = Date.now();
            const timer = window.setInterval(() => {
                if (isGoogleMapsReady()) {
                    window.clearInterval(timer);
                    resolve(true);
                    return;
                }

                if (Date.now() - startedAt >= timeoutMs) {
                    window.clearInterval(timer);
                    resolve(false);
                }
            }, 120);
        });
    }

    function getGoogleMapId() {
        const cfg = getConfig();
        const configuredMapId = String(cfg.googleMapsMapId || cfg.googleMapsMapID || cfg.mapId || '').trim();

        // AdvancedMarkerElement için mapId zorunlu. Canlı ortamda mutlaka gerçek GOOGLE_MAPS_MAP_ID kullanın.
        // Boş kalırsa sayfa tamamen patlamasın diye Google'ın örnek mapId'siyle fallback yapıyoruz.
        return configuredMapId || 'DEMO_MAP_ID';
    }

    function getGoogleMapOptions(extraOptions = {}) {
        return Object.assign({
            mapId: getGoogleMapId(),
        }, extraOptions || {});
    }

    function getAdvancedMarkerClass() {
        return window.google?.maps?.marker?.AdvancedMarkerElement || null;
    }

    function detachGoogleMarker(marker) {
        if (!marker) return;

        if ('map' in marker) {
            marker.map = null;
            return;
        }

        if (typeof marker.setMap === 'function') {
            marker.setMap(null);
        }
    }

    function makeClusterContent(count) {
        const root = document.createElement('div');
        root.className = 'gm-cluster-marker';
        root.innerHTML = '<span>' + escapeHtml(count) + '</span>';
        return root;
    }

    function makeVertexContent(index, isClosable) {
        const root = document.createElement('div');
        root.className = 'gm-vertex-marker' + (index === 0 ? ' is-first' : '') + (isClosable ? ' is-closable' : '');
        root.title = isClosable ? i18n('map.close_area_and_search', 'Close area and search') : i18n('map.vertex_point', 'Drawing point');
        return root;
    }

    function showMapUnavailable(message) {
        ['ad-list-map', 'overlay-map'].forEach((id) => {
            const el = $(id);
            if (!el || el.querySelector('.google-map-unavailable')) return;
            const box = document.createElement('div');
            box.className = 'google-map-unavailable';
            box.innerHTML = '<span>' + escapeHtml(message || i18n('map.unavailable', 'Google Maps could not be loaded.')) + '</span>';
            el.appendChild(box);
        });
    }
    function frontIsAuthed() {
        var cfg = getConfig();
        if (typeof cfg.isAuthed !== 'undefined') return !!cfg.isAuthed;
        if (typeof window.FRONT_IS_AUTHED !== 'undefined') return !!window.FRONT_IS_AUTHED;
        return !!(window.FRONT_ACTOR_KEY && window.FRONT_ACTOR_KEY !== 'guest');
    }

    function frontLoginUrl(fallback) {
        var cfg = getConfig();
        return fallback || cfg.loginUrl || window.FRONT_LOGIN_URL || '/giris';
    }

    function closeAnyFancybox() {
        if (window.Fancybox && typeof window.Fancybox.close === 'function') {
            window.Fancybox.close();
            return;
        }
        if (window.jQuery && window.jQuery.fancybox && typeof window.jQuery.fancybox.close === 'function') {
            window.jQuery.fancybox.close();
        }
    }

    function requireFrontAuth(loginUrl, options) {
        var opts = Object.assign({
            redirect: false,
            closeModal: true,
            title: i18n('auth.required_title', 'Sign in required'),
            message: i18n('auth.required_message', 'Sign in or create an account to perform this action.')
        }, options || {});

        if (frontIsAuthed()) return true;

        if (opts.closeModal) closeAnyFancybox();

        var url = frontLoginUrl(loginUrl);

        if (window.UI && typeof window.UI.openAuthRequired === 'function') {
            window.UI.openAuthRequired({
                loginUrl: url,
                title: opts.title,
                message: opts.message
            });
        } else {
            showToast('info', opts.title, opts.message);

            if (opts.redirect && url) {
                setTimeout(() => {
                    window.location.href = url;
                }, 650);
            }
        }

        return false;
    }


    // URL Helper
    function buildUrlWith(paramsPatch, paramsDelete) {
        var url = new URL(window.location.href);
        var params = url.searchParams;
        (paramsDelete || []).forEach(k => params.delete(k));
        Object.keys(paramsPatch || {}).forEach(k => {
            var v = paramsPatch[k];
            if (v === null || v === undefined || String(v).trim() === '') params.delete(k);
            else params.set(k, String(v));
        });
        params.delete('page');
        url.search = params.toString();
        return url.toString();
    }

    // Input Helpers
    function formValue(name) {
        var form = $('listFilterForm');
        if (!form) return '';
        var el = form.querySelector('[name="' + name + '"]');
        if (!el) return '';
        if (el.type === 'radio') {
            var checked = form.querySelector('[name="' + name + '"]:checked');
            return checked ? String(checked.value || '').trim() : '';
        }
        return String(el.value || '').trim();
    }

    function transactionLabelFromDom(transactionType) {
        var type = String(transactionType || '1');
        var form = $('listFilterForm');

        if (form) {
            var radio = form.querySelector('input[name="transaction_type"][value="' + type + '"]');
            var label = radio && radio.closest ? radio.closest('label') : null;
            var small = label ? label.querySelector('small') : null;
            var domText = small ? String(small.textContent || '').trim() : '';

            // Blade aktif locale ile doğru metni zaten basıyor.
            // JS/Vue sonradan etiketi güncellerken bu çeviriyi aynen koruyoruz.
            if (domText) return domText;
        }

        return type === '2'
            ? i18n('transaction.rent', 'For Rent')
            : i18n('transaction.sale', 'For Sale');
    }

    function popupValue(popupEl, name) {
        if (!popupEl) return '';
        if (name === 'transaction_type' || name === 'category_id') {
            var checked = popupEl.querySelector(`input[name="${name}"]:checked`);
            return checked ? checked.value : '';
        }
        var el = popupEl.querySelector(`[name="${name}"]`);
        if (!el) return '';
        return String(el.value || '').trim();
    }

    function currentVal(selectEl) {
        return selectEl ? String(selectEl.value || '').trim() : '';
    }

    // Filter Dict Maps
    function buildMapsFromDict() {
        var cfg = getConfig();
        var dict = cfg.filterDict || window.FILTER_DICT || {};
        var catMap = {};
        (dict.categories || []).forEach(x => { if (x && x.id != null) catMap[String(x.id)] = String(x.name || ''); });
        return {catMap: catMap};
    }

    function updateTopLabelsAndCount() {
        var maps = buildMapsFromDict();
        var tt = formValue('transaction_type') || '1';
        var ttEl = $('tt-label');
        if (ttEl) ttEl.textContent = transactionLabelFromDom(tt);

        var catId = formValue('category_id');
        var catEl = $('cat-label');
        if (catEl) {
            if (!catId || ['all', '0', '*'].includes(String(catId).toLowerCase())) catEl.textContent = i18n('common.all', 'All');
            else catEl.textContent = maps.catMap[String(catId)] || (i18n('category.prefix', 'Category #') + catId);
        }

        var count = 0;
        if (tt === '1' || tt === '2') count++;
        if (catId) count++;
        if (formValue('min_price') || formValue('price_min')) count++;
        if (formValue('max_price') || formValue('price_max')) count++;
        if (formValue('m2_min')) count++;
        if (formValue('m2_max')) count++;
        if (formValue('country_id')) count++;
        if (formValue('city_id')) count++;
        if (formValue('district_id')) count++;
        if (formValue('quarter_id')) count++;
        if (formValue('bbox')) count++;
        if (formValue('poly')) count++;

        var cntEl = $('all-filter-count');
        if (cntEl) cntEl.textContent = String(count);
    }

    // -------------------------
    // Geo Parse Logic (Google Maps uyumlu)
    // -------------------------
    function parseBboxStringRaw(str) {
        if (!str) return null;
        var p = String(str).split(',').map(v => parseFloat(v.trim()));
        if (p.length !== 4 || p.some(x => !isFinite(x))) return null;
        if (p[0] >= p[2] || p[1] >= p[3]) return null;
        return {south: p[0], west: p[1], north: p[2], east: p[3]};
    }

    function parsePolyStringRaw(str) {
        if (!str) return null;
        var pts = String(str).split('|').map(pair => {
            var a = pair.split(',').map(v => parseFloat(String(v).trim()));
            return (a.length !== 2 || !isFinite(a[0]) || !isFinite(a[1])) ? null : {lat: a[0], lng: a[1]};
        }).filter(Boolean);
        return pts.length >= 3 ? pts : null;
    }

    function parseBboxStringToBounds(str) {
        var raw = parseBboxStringRaw(str);
        if (!raw) return null;

        if (isGoogleMapsReady()) {
            return new google.maps.LatLngBounds(
                {lat: raw.south, lng: raw.west},
                {lat: raw.north, lng: raw.east}
            );
        }

        return raw;
    }

    function bboxStringFromBounds(bounds) {
        if (!bounds) return null;

        if (typeof bounds.getSouthWest === 'function' && typeof bounds.getNorthEast === 'function') {
            var sw = bounds.getSouthWest();
            var ne = bounds.getNorthEast();
            return [sw.lat(), sw.lng(), ne.lat(), ne.lng()].map(v => Number(v).toFixed(6)).join(',');
        }

        if (bounds.south != null && bounds.west != null && bounds.north != null && bounds.east != null) {
            return [bounds.south, bounds.west, bounds.north, bounds.east].map(v => Number(v).toFixed(6)).join(',');
        }

        return null;
    }

    function parsePolyStringToLatLngs(str) {
        var raw = parsePolyStringRaw(str);
        if (!raw) return null;

        if (isGoogleMapsReady()) {
            return raw.map(p => new google.maps.LatLng(p.lat, p.lng));
        }

        return raw;
    }

    function latLngToPlain(ll) {
        if (!ll) return null;
        if (typeof ll.lat === 'function' && typeof ll.lng === 'function') {
            return {lat: ll.lat(), lng: ll.lng()};
        }
        return {lat: Number(ll.lat), lng: Number(ll.lng)};
    }

    function polyStringFromLatLngs(latlngs) {
        if (!latlngs) return null;
        var arr = Array.isArray(latlngs) ? latlngs : [];
        if (arr.length < 3) return null;

        return arr.map(ll => {
            var p = latLngToPlain(ll);
            return p ? p.lat.toFixed(6) + ',' + p.lng.toFixed(6) : null;
        }).filter(Boolean).join('|');
    }

    function boundsFromPath(path) {
        if (!path || !path.length || !isGoogleMapsReady()) return null;
        var bounds = new google.maps.LatLngBounds();
        path.forEach(ll => bounds.extend(ll));
        return bounds;
    }

    function centerFromConfig(defaultZoomOnly = false) {
        var cfg = getConfig();
        var center = cfg.defaultCenter || [40.2330916, 28.9824323];
        return {
            center: {lat: parseFloat(center[0]) || 40.2330916, lng: parseFloat(center[1]) || 28.9824323},
            zoom: defaultZoomOnly ? (cfg.defaultZoom || 12) : (cfg.defaultZoom || 12)
        };
    }

    function hasGeoFilter() {
        var cfg = getConfig();
        return !!parseBboxStringRaw(cfg.initBbox) || !!parsePolyStringRaw(cfg.initPoly);
    }

    // -------------------------
    // Toast
    // -------------------------
    function showToast(type, title, msg) {
        var root = document.querySelector('.toast-root');
        if (!root) {
            root = document.createElement('div');
            root.className = 'toast-root';
            document.body.appendChild(root);
        }
        var iconHtml = '<i class="ph-light ph-info"></i>';
        if (type === 'success') iconHtml = '<i class="ph-light ph-check-circle"></i>';
        if (type === 'error') iconHtml = '<i class="ph-light ph-warning-circle"></i>';

        var t = document.createElement('div');
        t.className = 'toast ' + (type || 'info');
        t.innerHTML = `<div class="t-ico">${iconHtml}</div><div class="t-body"><div class="t-title">${escapeHtml(title)}</div><div class="t-msg">${escapeHtml(msg)}</div></div>`;
        root.appendChild(t);
        requestAnimationFrame(() => t.classList.add('show'));
        setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 250); }, 2600);
    }

    // -------------------------
    // All Filters Popup + Location Selects
    // -------------------------
    function initAllFiltersPopup() {
        if (window.__ADLIST_FILTER_POPUP_INITED__) return;
        window.__ADLIST_FILTER_POPUP_INITED__ = true;

        // Yeni Vue filtre popup'ı aktifse eski inline popup akışını bağlamıyoruz.
        // Böylece #adlist-open-filters tıklaması tek kaynak olarak SearchFilterPopup.vue üzerinden çalışır.
        if (document.getElementById('vue-search-filter')) {
            var vueOpenBtn = $('adlist-open-filters');
            if (vueOpenBtn && vueOpenBtn.dataset.vueFilterBound !== '1') {
                vueOpenBtn.dataset.vueFilterBound = '1';
                vueOpenBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    window.dispatchEvent(new CustomEvent('open-filter-popup'));
                });
            }
            return;
        }

        var popup = $('adlist-search-filter-popup');
        var overlay = $('adlist-sf-overlay');
        var openBtn = $('adlist-open-filters');
        var closeBtn = $('adlist-sf-close');
        var applyBtn = $('adlist-sf-apply');
        var clearBtn = $('adlist-sf-clear');
        if (!popup || !overlay) return;


        var selCountry = $('adlistSfCountry');
        var selCity = $('adlistSfCity');
        var selDistrict = $('adlistSfDistrict');
        var selNeigh = $('adlistSfNeighborhood');

        function getCheckedLabelText(groupName, fallbackText) {
            var checked = popup.querySelector(`input[name="${groupName}"]:checked`);
            if(!checked) return fallbackText;
            var label = checked.closest('label');
            var sm = label ? label.querySelector('small') : null;
            return sm ? sm.textContent.trim() : fallbackText;
        }

        function rangeLabel(minVal, maxVal, suffix) {
            minVal = (minVal || '').trim();
            maxVal = (maxVal || '').trim();
            if (!minVal && !maxVal) return i18n('common.all', 'All');
            if (minVal && maxVal) return minVal + ' - ' + maxVal + (suffix ? ' ' + suffix : '');
            if (minVal) return minVal + (suffix ? ' ' + suffix : '') + ' +';
            return '0 - ' + maxVal + (suffix ? ' ' + suffix : '');
        }

        function updatePopupTopLabels() {
            var ttEl = $('sf-tt-label');
            if (ttEl) ttEl.textContent = getCheckedLabelText('transaction_type', i18n('transaction.sale', 'For Sale'));
            var catEl = $('sf-cat-label');
            if (catEl) catEl.textContent = getCheckedLabelText('category_id', i18n('common.all', 'All'));

            var priceEl = $('sf-price-label');
            if (priceEl) priceEl.textContent = rangeLabel(popupValue(popup, 'min_price'), popupValue(popup, 'max_price'), 'TL');

            var areaEl = $('sf-area-label');
            if (areaEl) areaEl.textContent = rangeLabel(popupValue(popup, 'm2_min'), popupValue(popup, 'm2_max'), 'm²');
        }

        function refreshRoomSelectedUI() {
            popup.querySelectorAll('.filter-option-label').forEach(lb => {
                var inp = lb.querySelector('input[type="radio"]');
                if (inp) lb.classList.toggle('selected', !!inp.checked);
            });
        }

        function openPopup() {
            popup.style.display = 'block';
            setTimeout(() => popup.classList.add('open', 'active'), 10);
            popup.setAttribute('aria-hidden', 'false');
            document.body.classList.add('is-filters-open', 'nav-opened');
            if (openBtn) openBtn.classList.add('hero-search-filter-close');
            updatePopupTopLabels();
            refreshRoomSelectedUI();

            if(selCountry && selCountry.value && (!selCity || selCity.options.length <= 1)) {
                initLocationSelections();
            }
        }

        function closePopup() {
            popup.classList.remove('open', 'active');
            setTimeout(() => popup.style.display = 'none', 300);
            popup.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('is-filters-open', 'nav-opened');
            if (openBtn) openBtn.classList.remove('hero-search-filter-close');
        }

        if (openBtn) openBtn.onclick = (e) => { e.preventDefault(); openPopup(); };
        if (closeBtn) closeBtn.onclick = (e) => { e.preventDefault(); closePopup(); };
        if (overlay) overlay.onclick = (e) => { if (e.target === overlay) closePopup(); };
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && popup.style.display === 'block') closePopup(); });

        popup.querySelectorAll('.js-sf-just-close').forEach(btn => btn.onclick = (e) => { e.preventDefault(); closePopup(); });
        popup.addEventListener('change', (e) => {
            updatePopupTopLabels();
        });
        popup.addEventListener('input', (e) => {
            if (['min_price', 'max_price', 'm2_min', 'm2_max'].includes(e.target.name)) updatePopupTopLabels();
        });

        function normalizeItems(json) { return (json && (json.items || json.data)) ? (json.items || json.data) : []; }
        function populateSelect(selectEl, items, placeholder) {
            if (!selectEl) return;
            var selected = selectEl.getAttribute('data-selected') || '';
            selectEl.innerHTML = `<option value="">${placeholder || i18n('common.all', 'All')}</option>`;
            (items || []).forEach(x => {
                var val = x.id, lbl = x.name || x.title;
                var opt = document.createElement('option');
                opt.value = val; opt.textContent = lbl;
                if (String(val) === String(selected)) opt.selected = true;
                selectEl.appendChild(opt);
            });
            selectEl.disabled = false;
        }

        async function fetchJson(url, params) {
            try {
                var u = new URL(url, window.location.origin);
                Object.keys(params).forEach(k => { if (params[k]) u.searchParams.set(k, params[k]); });
                var res = await fetch(u.toString(), { headers: { 'Accept': 'application/json' } });
                return res.ok ? await res.json() : null;
            } catch (e) { return null; }
        }

        function setDisabled(el, dis) { if (el) el.disabled = !!dis; }
        function setDataSelected(el, val) { if (el) el.setAttribute('data-selected', val || ''); }

        async function initLocationSelections() {
            if (!selCountry) return;
            var countryUrl = popup.getAttribute('data-loc-countries');
            if (countryUrl) {
                var json = await fetchJson(countryUrl, { transaction_type: popupValue(popup, 'transaction_type'), category_id: popupValue(popup, 'category_id') });
                populateSelect(selCountry, normalizeItems(json), i18n('location.country_all', 'Country (All)'));
            }

            var cId = selCountry.getAttribute('data-selected');
            if(cId) {
                selCountry.value = cId;
                await triggerCityLoad(cId);
            } else { setDisabled(selCity, true); setDisabled(selDistrict, true); setDisabled(selNeigh, true); }
        }

        async function triggerCityLoad(countryId) {
            if(!countryId) { setDisabled(selCity, true); return; }
            var json = await fetchJson(popup.getAttribute('data-loc-cities'), { country_id: countryId });
            populateSelect(selCity, normalizeItems(json), i18n('location.city_all', 'City (All)'));

            var ciId = selCity.getAttribute('data-selected');
            if(ciId) { selCity.value = ciId; await triggerDistrictLoad(ciId); }
            else { setDisabled(selDistrict, true); setDisabled(selNeigh, true); }
        }

        async function triggerDistrictLoad(cityId) {
            if(!cityId) { setDisabled(selDistrict, true); return; }
            var json = await fetchJson(popup.getAttribute('data-loc-districts'), { city_id: cityId });
            populateSelect(selDistrict, normalizeItems(json), i18n('location.district_all', 'District (All)'));

            var dId = selDistrict.getAttribute('data-selected');
            if(dId) { selDistrict.value = dId; await triggerNeighLoad(dId); }
            else { setDisabled(selNeigh, true); }
        }

        async function triggerNeighLoad(distId) {
            if(!distId) { setDisabled(selNeigh, true); return; }
            var json = await fetchJson(popup.getAttribute('data-loc-neighborhoods'), { district_id: distId });
            populateSelect(selNeigh, normalizeItems(json), i18n('location.neighborhood_all', 'Neighborhood (All)'));
            var nId = selNeigh.getAttribute('data-selected');
            if(nId) selNeigh.value = nId;
        }

        if(selCountry) selCountry.onchange = () => { setDataSelected(selCity, ''); triggerCityLoad(currentVal(selCountry)); };
        if(selCity) selCity.onchange = () => { setDataSelected(selDistrict, ''); triggerDistrictLoad(currentVal(selCity)); };
        if(selDistrict) selDistrict.onchange = () => { setDataSelected(selNeigh, ''); triggerNeighLoad(currentVal(selDistrict)); };

        initLocationSelections();

        if (applyBtn) {
            applyBtn.onclick = (e) => {
                e.preventDefault();
                var params = {
                    transaction_type: popupValue(popup, 'transaction_type'),
                    category_id: popupValue(popup, 'category_id'),
                    min_price: popupValue(popup, 'min_price'),
                    max_price: popupValue(popup, 'max_price'),
                    m2_min: popupValue(popup, 'm2_min'),
                    m2_max: popupValue(popup, 'm2_max'),
                    country_id: currentVal(selCountry),
                    city_id: currentVal(selCity),
                    district_id: currentVal(selDistrict),
                    quarter_id: currentVal(selNeigh)
                };

                if (window.AD_LIST_VUE_FETCH) {
                    window.AD_LIST_VUE_FETCH(params);
                    closePopup();
                } else {
                    window.location.href = buildUrlWith(params, ['page']);
                }
            };
        }

        if (clearBtn) {
            clearBtn.onclick = (e) => {
                e.preventDefault();
                window.location.href = buildUrlWith({}, ['transaction_type', 'category_id', 'min_price', 'max_price', 'm2_min', 'm2_max', 'country_id', 'city_id', 'district_id', 'quarter_id', 'bbox', 'poly', 'q']);
            };
        }
    }

    // -------------------------
    // 1. Sidebar Map (Gruplama Ayarı Yapıldı)
    // -------------------------
    function initSidebarMap() {
        if (!isGoogleMapsReady()) return null;

        var mapEl = $('ad-list-map');
        if (!mapEl) return null;

        var cfg = getConfig();
        var data = Array.isArray(cfg.mapPoints) ? cfg.mapPoints : [];
        var defaults = centerFromConfig();

        var map = new google.maps.Map(mapEl, getGoogleMapOptions({
            center: defaults.center,
            zoom: defaults.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            gestureHandling: 'cooperative',
            clickableIcons: true,
            streetViewControl: true,
            fullscreenControl: true,
            scaleControl: true,
            zoomControl: true,
            zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
            streetViewControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
            fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP },
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_RIGHT,
                mapTypeIds: [
                    google.maps.MapTypeId.ROADMAP,
                    google.maps.MapTypeId.SATELLITE,
                    google.maps.MapTypeId.HYBRID,
                    google.maps.MapTypeId.TERRAIN
                ]
            }
        }));

        document.querySelectorAll('[data-hm-list-map-type]').forEach(button => {
            button.addEventListener('click', () => map.setMapTypeId(button.dataset.hmListMapType));
        });
        map.addListener('maptypeid_changed', () => {
            document.querySelectorAll('[data-hm-list-map-type]').forEach(button => {
                button.setAttribute('aria-pressed', String(button.dataset.hmListMapType === map.getMapTypeId()));
            });
        });

        mapEl.addEventListener('mouseenter', () => map.setOptions({ gestureHandling: 'greedy' }));
        mapEl.addEventListener('mouseleave', () => map.setOptions({ gestureHandling: 'cooperative' }));

        var AdvancedMarker = getAdvancedMarkerClass();
        var clusterer = null;
        var markers = [];
        var markersById = {};
        var activeMarkerId = null;
        var activeMarkerSource = null;
        var listHoverTimer = null;
        var listHoverSeq = 0;
        var mapFrameEl = mapEl.closest('.search-layout-map') || mapEl.parentElement || mapEl;
        var hoverCardEl = $('map-hover-card');
        var hoverCardOverlay = null;
        var hoverCardLatLng = null;
        var hoverCardItemId = null;
        var hoverCardHideTimer = null;
        var hoverCardHovered = false;
        var hoverCardHideDelay = 190;

        // Harita sürükleme sırasında marker/card click event'i de tetiklenebiliyor.
        // Bu state, drag sonrası kısa süreli tıklama navigasyonunu engeller.
        var isMapDragging = false;
        var suppressClickUntil = 0;
        var pointerDownState = null;
        var dragClickThreshold = 8;
        var dragClickSuppressMs = 520;

        var shapeOverlays = [];

        function normalizeMarkerId(id) {
            if (id === null || id === undefined) return '';
            var str = String(id).trim();
            return str && str !== '0' ? str : '';
        }

        function cancelPendingListHover() {
            listHoverSeq++;
            if (listHoverTimer) {
                window.clearTimeout(listHoverTimer);
                listHoverTimer = null;
            }
        }

        function hardClearMarkerDom() {
            if (!mapEl) return;
            mapEl.querySelectorAll('.custom-marker-icon.is-active, .custom-marker-icon.is-hovered').forEach(function (el) {
                el.classList.remove('is-active', 'is-hovered');
            });
        }

        function resetEveryMarkerExcept(exceptId) {
            exceptId = normalizeMarkerId(exceptId);
            Object.keys(markersById).forEach(function (key) {
                if (exceptId && key === exceptId) return;
                updateMarkerAppearance(markersById[key], false);
            });
            hardClearMarkerDom();
        }

        function setActiveMarker(id, source, options) {
            var opts = Object.assign({ pan: false, showCard: false }, options || {});
            var normalizedId = normalizeMarkerId(id);

            cancelPendingListHover();

            if (!normalizedId || !markersById[normalizedId]) {
                clearActiveState();
                return;
            }

            var rec = markersById[normalizedId];

            resetEveryMarkerExcept(normalizedId);
            updateMarkerAppearance(rec, true);

            activeMarkerId = normalizedId;
            activeMarkerSource = source || 'manual';

            if (opts.pan && rec.position) map.panTo(rec.position);
            if (opts.showCard) showCard(rec.data, rec.position);
            else hideCard(true);
        }

        function scheduleListHover(id) {
            var normalizedId = normalizeMarkerId(id);
            cancelPendingListHover();

            if (!normalizedId) {
                clearActiveState();
                return;
            }

            var seq = ++listHoverSeq;
            listHoverTimer = window.setTimeout(function () {
                if (seq !== listHoverSeq) return;
                listHoverTimer = null;
                setActiveMarker(normalizedId, 'list', { pan: true });
            }, 35);
        }

        function clearActiveState() {
            cancelPendingListHover();
            hideCard();
            resetEveryMarkerExcept(null);
            activeMarkerId = null;
            activeMarkerSource = null;
        }

        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        }

        function normalizeMapPriceNumber(value) {
            if (value === null || value === undefined || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            var raw = String(value || '').trim();
            if (!raw || !/[0-9]/.test(raw)) return 0;

            raw = raw
                .replace(/\s+/g, '')
                .replace(/[^0-9,.-]/g, '');

            if (!raw || !/[0-9]/.test(raw)) return 0;

            var hasComma = raw.indexOf(',') !== -1;
            var hasDot = raw.indexOf('.') !== -1;
            var normalized = raw;

            if (hasComma && hasDot) {
                var lastComma = raw.lastIndexOf(',');
                var lastDot = raw.lastIndexOf('.');
                var decimalSep = lastComma > lastDot ? ',' : '.';
                var thousandsSep = decimalSep === ',' ? '.' : ',';

                normalized = raw
                    .split(thousandsSep).join('')
                    .replace(decimalSep, '.');
            } else if (hasComma || hasDot) {
                var sep = hasComma ? ',' : '.';
                var parts = raw.split(sep);
                var lastPart = parts[parts.length - 1] || '';

                if (parts.length > 2) {
                    normalized = (lastPart.length > 0 && lastPart.length <= 2)
                        ? parts.slice(0, -1).join('') + '.' + lastPart
                        : parts.join('');
                } else if (parts.length === 2) {
                    var integerPart = parts[0] || '';
                    var fractionPart = parts[1] || '';

                    normalized = (fractionPart.length > 0 && fractionPart.length <= 2)
                        ? integerPart + '.' + fractionPart
                        : integerPart + fractionPart;
                }
            }

            var number = Number.parseFloat(normalized);
            return Number.isFinite(number) ? number : 0;
        }

        function itemHasHiddenMapPrice(item) {
            if (!item || typeof item !== 'object') return false;

            var flags = [item.price_hidden, item.price_status, item.hide_price, item.is_price_hidden];
            for (var i = 0; i < flags.length; i++) {
                if (flags[i] === true || flags[i] === 1) return true;
                var text = String(flags[i] || '').trim().toLowerCase();
                if (['1', 'true', 'yes', 'evet', 'on'].indexOf(text) !== -1) return true;
            }

            var labels = [item.price_label, item.price_full, item.price, item.show_price];
            return labels.some(function (label) {
                return String(label || '').trim().toLocaleLowerCase('tr-TR').indexOf('fiyat sorunuz') !== -1;
            });
        }

        function formatFullMapTlPrice(item) {
            if (itemHasHiddenMapPrice(item)) return i18n('map.price_ask', 'Ask for price');

            var numericCandidates = [
                item && item.price_value,
                item && item.price_numeric,
                item && item.raw_price,
                item && item.price_raw
            ];

            for (var i = 0; i < numericCandidates.length; i++) {
                var number = normalizeMapPriceNumber(numericCandidates[i]);
                if (number > 0) return Math.round(number).toLocaleString('tr-TR') + ' TL';
            }

            var labelCandidates = [
                item && item.price_label,
                item && item.price_full,
                item && item.price,
                item && item.formatted_price,
                item && item.show_price
            ];

            for (var j = 0; j < labelCandidates.length; j++) {
                var label = String(labelCandidates[j] || '').trim();
                if (!label || label === i18n('price.label', 'Price') || label === 'Fiyat') continue;

                var labelNumber = normalizeMapPriceNumber(label);
                if (labelNumber > 0) return Math.round(labelNumber).toLocaleString('tr-TR') + ' TL';

                return label.replace(/₺/g, 'TL');
            }

            return i18n('map.price_unavailable', 'Price unavailable');
        }

        function markerPrice(item) {
            return formatFullMapTlPrice(item);
        }

        function markerLogo(item) {
            var candidates = [
                item && item.agency_logo,
                item && item.owner_logo,
                item && item.marker_logo,
                item && item.logo
            ];

            for (var i = 0; i < candidates.length; i++) {
                var value = String(candidates[i] || '').trim();
                if (value) return value;
            }

            return '';
        }

        function markerHtml(item, active) {
            var price = escapeHtml(markerPrice(item));
            var logo = markerLogo(item);
            var safeLogo = escapeHtml(logo);
            var cls = 'custom-marker-icon'
                + (active ? ' is-active is-hovered' : '')
                + (item.on_list ? ' is-listed' : '')
                + (logo ? ' has-agency-logo' : '');
            var root = document.createElement('div');

            root.className = cls;
            root.setAttribute('data-marker-ad-id', String(item.id || ''));
            root.innerHTML = '<div class="marker-dot" aria-hidden="true"></div>'
                + (logo ? '<div class="marker-logo-badge"><img src="' + safeLogo + '" alt="' + escapeHtml(i18n('agency.logo_alt', 'Agency logo')) + '"></div>' : '')
                + '<div class="marker-price-label">' + price + '</div>';

            var img = root.querySelector('.marker-logo-badge img');
            if (img) {
                img.onerror = function () {
                    root.classList.remove('has-agency-logo');
                    var badge = root.querySelector('.marker-logo-badge');
                    if (badge) badge.remove();
                };
            }

            return root;
        }

        function fallbackDotIcon(active) {
            return {
                path: google.maps.SymbolPath.CIRCLE,
                scale: active ? 9 : 7,
                fillColor: '#da241d',
                fillOpacity: 1,
                strokeColor: '#ffffff',
                strokeWeight: 2
            };
        }

        function fallbackIcon(item, active) {
            var logo = markerLogo(item);

            if (logo) {
                var size = active ? 42 : 36;

                return {
                    url: logo,
                    scaledSize: new google.maps.Size(size, size),
                    anchor: new google.maps.Point(size / 2, size / 2)
                };
            }

            return fallbackDotIcon(active);
        }

        function getPointerPoint(event) {
            if (!event) return null;

            var src = event;
            if (event.domEvent) src = event.domEvent;

            if (src.touches && src.touches.length) {
                return { x: Number(src.touches[0].clientX), y: Number(src.touches[0].clientY) };
            }

            if (src.changedTouches && src.changedTouches.length) {
                return { x: Number(src.changedTouches[0].clientX), y: Number(src.changedTouches[0].clientY) };
            }

            if (typeof src.clientX === 'number' && typeof src.clientY === 'number') {
                return { x: Number(src.clientX), y: Number(src.clientY) };
            }

            return null;
        }

        function suppressNextMapClick(durationMs) {
            suppressClickUntil = Math.max(
                suppressClickUntil,
                Date.now() + (durationMs || dragClickSuppressMs)
            );
        }

        function shouldSuppressMapNavigation(event) {
            if (isMapDragging || Date.now() < suppressClickUntil) return true;

            var src = event && event.domEvent ? event.domEvent : event;
            if (src && src.defaultPrevented) return true;

            return false;
        }

        function navigateToAdUrl(url, event) {
            if (!url) return;

            if (shouldSuppressMapNavigation(event)) {
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
                if (event && event.domEvent && typeof event.domEvent.preventDefault === 'function') event.domEvent.preventDefault();
                if (event && event.domEvent && typeof event.domEvent.stopPropagation === 'function') event.domEvent.stopPropagation();
                return;
            }

            if (event && typeof event.preventDefault === 'function') event.preventDefault();
            window.location.href = url;
        }

        function beginPointerDragGuard(event, source) {
            var point = getPointerPoint(event);
            if (!point) return;

            pointerDownState = {
                x: point.x,
                y: point.y,
                moved: false,
                source: source || 'map',
                startedAt: Date.now()
            };
        }

        function updatePointerDragGuard(event) {
            if (!pointerDownState) return;

            var point = getPointerPoint(event);
            if (!point) return;

            var dx = Math.abs(point.x - pointerDownState.x);
            var dy = Math.abs(point.y - pointerDownState.y);

            if (dx > dragClickThreshold || dy > dragClickThreshold) {
                pointerDownState.moved = true;
                suppressNextMapClick();
            }
        }

        function endPointerDragGuard() {
            if (pointerDownState && pointerDownState.moved) {
                suppressNextMapClick();
            }

            pointerDownState = null;
        }

        function bindDragClickGuard(el, source) {
            if (!el || el.__adListDragClickGuardBound) return;
            el.__adListDragClickGuardBound = true;

            var start = function (event) { beginPointerDragGuard(event, source); };
            var move = function (event) { updatePointerDragGuard(event); };
            var end = function () { endPointerDragGuard(); };

            el.addEventListener('pointerdown', start, { passive: true });
            el.addEventListener('pointermove', move, { passive: true });
            el.addEventListener('pointerup', end, { passive: true });
            el.addEventListener('pointercancel', end, { passive: true });

            // Eski iOS/WebView benzeri ortamlarda pointer event eksik kalırsa güvenli fallback.
            el.addEventListener('touchstart', start, { passive: true });
            el.addEventListener('touchmove', move, { passive: true });
            el.addEventListener('touchend', end, { passive: true });
            el.addEventListener('mousedown', start, { passive: true });
            el.addEventListener('mousemove', move, { passive: true });
            el.addEventListener('mouseup', end, { passive: true });
        }

        function cancelHoverCardHide() {
            if (hoverCardHideTimer) {
                window.clearTimeout(hoverCardHideTimer);
                hoverCardHideTimer = null;
            }
        }

        function ensureHoverCardOverlay() {
            if (hoverCardOverlay) return hoverCardOverlay;

            hoverCardOverlay = new google.maps.OverlayView();
            hoverCardOverlay.onAdd = function () {};
            hoverCardOverlay.draw = function () { positionHoverCard(); };
            hoverCardOverlay.onRemove = function () {};
            hoverCardOverlay.setMap(map);

            return hoverCardOverlay;
        }

        function toGoogleLatLng(position) {
            if (!position) return null;
            if (position instanceof google.maps.LatLng) return position;

            var plain = latLngToPlain(position);
            if (!plain || !isFinite(plain.lat) || !isFinite(plain.lng)) return null;
            return new google.maps.LatLng(plain.lat, plain.lng);
        }

        function buildHoverCardHtml(item) {
            var image = escapeHtml(item.img || '/front/images/placeholders/ad-cover.jpg');
            var price = escapeHtml(markerPrice(item) || i18n('map.price_unavailable', 'Price unavailable'));
            var title = escapeHtml(item.name || i18n('map.listing_detail', 'Listing details'));
            var loc = escapeHtml(item.loc || i18n('map.location_unavailable', 'Location unavailable'));

            return '' +
                '<div class="mhc-media">' +
                '<img src="' + image + '" alt="' + title + '" loading="lazy">' +
                '<div class="mhc-badge">' + escapeHtml(i18n('map.map_badge', 'Map listing')) + '</div>' +
                '</div>' +
                '<div class="mhc-body">' +
                '<div class="mhc-price">' + price + '</div>' +
                '<div class="mhc-title">' + title + '</div>' +
                '<div class="mhc-meta"><i class="ph-light ph-map-pin"></i><span>' + loc + '</span></div>' +
                '<div class="mhc-action"><span>' + escapeHtml(i18n('map.inspect_listing', 'View listing')) + '</span><i class="ph-light ph-arrow-right"></i></div>' +
                '</div>';
        }

        function getMapContainerPoint(latLng) {
            if (!latLng || !hoverCardOverlay) return null;

            var projection = hoverCardOverlay.getProjection && hoverCardOverlay.getProjection();
            if (!projection) return null;

            var point = null;

            // Kart .search-layout-map içinde absolute duruyor. Bu yüzden Google'ın pane
            // koordinatı yerine map container koordinatı kullanılmalı; aksi halde pan/drag
            // sonrası kart marker'dan kopuk, alakasız noktalarda görünebilir.
            if (typeof projection.fromLatLngToContainerPixel === 'function') {
                point = projection.fromLatLngToContainerPixel(latLng);
            } else if (typeof projection.fromLatLngToDivPixel === 'function') {
                point = projection.fromLatLngToDivPixel(latLng);
            }

            if (!point) return null;

            var mapRect = mapEl.getBoundingClientRect();
            var frameRect = mapFrameEl.getBoundingClientRect();

            return {
                x: Number(point.x) + (mapRect.left - frameRect.left),
                y: Number(point.y) + (mapRect.top - frameRect.top)
            };
        }

        function getHoverCardMarkerOffsetY() {
            var rec = hoverCardItemId ? markersById[hoverCardItemId] : null;
            var data = rec && rec.data ? rec.data : null;

            // AdvancedMarker default anchor'ı marker'ın alt/orta noktasına yakın çalışır.
            // Kartı koordinatın kendisine değil, görünen ikonun üst merkezine yaklaştırıyoruz.
            if (data && data.on_list) return 48;
            return 30;
        }

        function setHoverCardArrowPosition(anchorX, cardCenterX, cardWidth) {
            if (!hoverCardEl || !cardWidth) return;

            var localX = anchorX - (cardCenterX - (cardWidth / 2));
            localX = Math.max(22, Math.min(localX, cardWidth - 22));
            hoverCardEl.style.setProperty('--mhc-arrow-left', localX + 'px');
        }

        function getHoverCardRecord() {
            var id = normalizeMarkerId(hoverCardItemId || activeMarkerId);
            return id ? (markersById[id] || null) : null;
        }

        function getVisibleTargetRect(el) {
            if (!el || typeof el.getBoundingClientRect !== 'function') return null;
            var rect = el.getBoundingClientRect();
            if (!rect || rect.width <= 0 || rect.height <= 0) return null;
            return rect;
        }

        function getMarkerDomAnchorPoint() {
            var rec = getHoverCardRecord();
            if (!rec || !rec.content || typeof rec.content.getBoundingClientRect !== 'function') return null;

            var frameRect = mapFrameEl.getBoundingClientRect();
            var mapRect = mapEl.getBoundingClientRect();
            var contentRect = getVisibleTargetRect(rec.content);
            if (!contentRect) return null;

            // Clusterer/Google repaint anında marker DOM'u kısa süre eski pane'de kalabiliyor.
            // Harita alanıyla kesişmiyorsa bu ölçümü kullanmayıp projection fallback'e düşüyoruz.
            var intersectsMap = !(
                contentRect.right < mapRect.left ||
                contentRect.left > mapRect.right ||
                contentRect.bottom < mapRect.top ||
                contentRect.top > mapRect.bottom
            );
            if (!intersectsMap) return null;

            var imgRect = getVisibleTargetRect(rec.content.querySelector('img'));
            var dotRect = getVisibleTargetRect(rec.content.querySelector('.marker-dot'));
            var targetRect = imgRect || dotRect || contentRect;

            return {
                x: (targetRect.left + (targetRect.width / 2)) - frameRect.left,
                // Kartın oku marker'ın tam tepesine değil, ikonun üst merkezine çok yakın bir noktaya baksın.
                // Böylece kart hem marker'a yapışık durur hem de favicon/aktif scale farklarında kaymaz.
                y: (targetRect.top - frameRect.top) - 6,
                source: 'dom'
            };
        }

        function clampNumber(value, min, max) {
            if (max < min) return min;
            return Math.max(min, Math.min(value, max));
        }

        function positionHoverCard() {
            if (!hoverCardEl || hoverCardEl.hidden || !hoverCardLatLng || !hoverCardOverlay) return;

            var point = getMapContainerPoint(hoverCardLatLng);
            if (!point) return;

            var frameWidth = mapFrameEl.clientWidth || mapEl.offsetWidth || 0;
            var frameHeight = mapFrameEl.clientHeight || mapEl.offsetHeight || 0;
            var mapRect = mapEl.getBoundingClientRect();
            var frameRect = mapFrameEl.getBoundingClientRect();
            var mapTop = mapRect.top - frameRect.top;
            var mapBottom = mapTop + (mapEl.offsetHeight || frameHeight);
            var mapLeft = mapRect.left - frameRect.left;
            var mapRight = mapLeft + (mapEl.offsetWidth || frameWidth);

            var cardWidth = hoverCardEl.offsetWidth || 306;
            var cardHeight = hoverCardEl.offsetHeight || 250;
            var safeX = 16;
            var safeY = 16;
            var gap = 16;

            var domAnchor = getMarkerDomAnchorPoint();
            var anchorX = domAnchor ? domAnchor.x : point.x;
            var anchorY = domAnchor ? domAnchor.y : (point.y - getHoverCardMarkerOffsetY());

            var minCenterX = mapLeft + (cardWidth / 2) + safeX;
            var maxCenterX = mapRight - (cardWidth / 2) - safeX;
            if (maxCenterX < minCenterX) {
                minCenterX = (cardWidth / 2) + safeX;
                maxCenterX = Math.max(minCenterX, frameWidth - (cardWidth / 2) - safeX);
            }

            var left = clampNumber(anchorX, minCenterX, maxCenterX);
            var roomAbove = anchorY - mapTop;
            var roomBelow = mapBottom - anchorY;
            var needRoom = cardHeight + gap + safeY;
            var shouldFlip = roomAbove < needRoom && roomBelow > roomAbove;

            var top;
            if (shouldFlip) {
                // CSS transform flipped durumda top değerini marker anchor'ı kabul eder.
                top = clampNumber(anchorY, mapTop + safeY, mapBottom - cardHeight - gap - safeY);
            } else {
                // Normal durumda top, kartın altındaki okun hedef anchor'ıdır.
                top = clampNumber(anchorY, mapTop + cardHeight + gap + safeY, mapBottom - safeY);
            }

            hoverCardEl.style.left = Math.round(left) + 'px';
            hoverCardEl.style.top = Math.round(top) + 'px';
            hoverCardEl.classList.toggle('is-flipped', !!shouldFlip);
            setHoverCardArrowPosition(anchorX, left, cardWidth);
        }

        function bindHoverCardEvents() {
            if (!hoverCardEl || hoverCardEl.__adListHoverCardBound) return;
            hoverCardEl.__adListHoverCardBound = true;

            hoverCardEl.addEventListener('mouseenter', function () {
                hoverCardHovered = true;
                cancelHoverCardHide();
            });

            hoverCardEl.addEventListener('mouseleave', function () {
                hoverCardHovered = false;
                if (activeMarkerSource === 'map') clearActiveState();
                else hideCard(true);
            });

            bindDragClickGuard(hoverCardEl, 'hover-card');

            hoverCardEl.addEventListener('click', function (event) {
                var url = hoverCardEl.getAttribute('data-url') || '';
                navigateToAdUrl(url, event);
            });
        }

        function showCard(item, position) {
            if (!item || !hoverCardEl) return;

            var latLng = toGoogleLatLng(position);
            if (!latLng) return;

            ensureHoverCardOverlay();
            bindHoverCardEvents();
            cancelHoverCardHide();

            hoverCardLatLng = latLng;
            hoverCardItemId = normalizeMarkerId(item.id);
            hoverCardEl.setAttribute('data-url', item.url || '');
            hoverCardEl.setAttribute('data-ad-id', hoverCardItemId || '');
            hoverCardEl.innerHTML = buildHoverCardHtml(item);
            hoverCardEl.hidden = false;

            var cardImage = hoverCardEl.querySelector('.mhc-media img');
            if (cardImage) {
                cardImage.addEventListener('load', positionHoverCard, { once: true });
            }

            window.requestAnimationFrame(function () {
                positionHoverCard();
                hoverCardEl.classList.add('is-visible');

                // Marker scale transition ve Google pane repaint bazı cihazlarda 1 frame geç oturuyor.
                // İki ek ölçüm, kartın marker üstüne kilitli kalmasını sağlar.
                window.requestAnimationFrame(positionHoverCard);
                window.setTimeout(positionHoverCard, 90);
            });
        }

        function hideCard(immediate) {
            cancelHoverCardHide();
            hoverCardHovered = false;
            hoverCardLatLng = null;
            hoverCardItemId = null;

            if (!hoverCardEl) return;

            hoverCardEl.classList.remove('is-visible', 'is-flipped');
            hoverCardEl.style.removeProperty('--mhc-arrow-left');
            hoverCardEl.removeAttribute('data-url');
            hoverCardEl.removeAttribute('data-ad-id');

            if (immediate === false) {
                window.setTimeout(function () {
                    if (!hoverCardEl.classList.contains('is-visible')) {
                        hoverCardEl.hidden = true;
                        hoverCardEl.innerHTML = '';
                    }
                }, 180);
                return;
            }

            hoverCardEl.hidden = true;
            hoverCardEl.innerHTML = '';
        }

        function scheduleMapCardClose(id) {
            cancelHoverCardHide();
            var normalizedId = normalizeMarkerId(id);

            hoverCardHideTimer = window.setTimeout(function () {
                hoverCardHideTimer = null;

                if (hoverCardHovered) return;

                if (activeMarkerSource === 'map' && activeMarkerId === normalizedId) {
                    clearActiveState();
                    return;
                }

                if (hoverCardItemId === normalizedId) hideCard(true);
            }, hoverCardHideDelay);
        }

        bindHoverCardEvents();
        bindDragClickGuard(mapEl, 'map');

        map.addListener('dragstart', function () {
            isMapDragging = true;
            suppressNextMapClick();
            hideCard(true);
        });

        map.addListener('dragend', function () {
            isMapDragging = false;
            suppressNextMapClick();
            hideCard(true);
        });

        map.addListener('idle', function () {
            isMapDragging = false;
        });

        map.addListener('bounds_changed', positionHoverCard);

        function bindAdvancedContent(rec) {
            if (!rec || !rec.content || rec.content.__adListMarkerBound) return;
            rec.content.__adListMarkerBound = true;

            bindDragClickGuard(rec.content, 'marker');

            rec.content.addEventListener('mouseenter', function () {
                if (isMapDragging || Date.now() < suppressClickUntil) return;
                setActiveMarker(rec.data.id, 'map', { showCard: true });
            });

            rec.content.addEventListener('mouseleave', function () {
                scheduleMapCardClose(rec.data.id);
            });

            rec.content.addEventListener('click', function (event) {
                navigateToAdUrl(rec.data.url, event);
            });
        }

        function updateMarkerAppearance(rec, active) {
            if (!rec || !rec.marker) return;
            var isActive = !!active;
            var zIndex = isActive ? 9999 : (rec.data.on_list ? 1000 : 1);

            if (rec.isAdvanced) {
                if (rec.content && rec.content.classList) {
                    rec.content.classList.toggle('is-listed', !!rec.data.on_list);
                    rec.content.classList.toggle('has-agency-logo', !!markerLogo(rec.data));
                    rec.content.classList.toggle('is-active', isActive);
                    rec.content.classList.toggle('is-hovered', isActive);
                }
                rec.marker.zIndex = zIndex;
                return;
            }

            rec.marker.setIcon(fallbackIcon(rec.data, isActive));
            rec.marker.setZIndex(zIndex);
        }

        function createMarker(item) {
            var lat = parseFloat(item.lat), lng = parseFloat(item.lng);
            if (!isFinite(lat) || !isFinite(lng)) return null;

            var position = {lat: lat, lng: lng};
            var rec;

            if (AdvancedMarker) {
                var content = markerHtml(item, false);
                var marker = new AdvancedMarker({
                    map: null,
                    position: position,
                    title: item.name || '',
                    content: content,
                    zIndex: item.on_list ? 1000 : 1
                });

                rec = {marker: marker, data: item, position: position, content: content, isAdvanced: true};
                bindAdvancedContent(rec);
                marker.addListener('click', (event) => { navigateToAdUrl(item.url, event); });
                return rec;
            }

            var marker = new google.maps.Marker({
                map: null,
                position: position,
                title: item.name || '',
                icon: fallbackIcon(item, false),
                zIndex: item.on_list ? 1000 : 1
            });
            rec = {marker: marker, data: item, position: position, isAdvanced: false};
            marker.addListener('mouseover', () => { if (!isMapDragging && Date.now() >= suppressClickUntil) setActiveMarker(item.id, 'map', { showCard: true }); });
            marker.addListener('mouseout', () => {
                scheduleMapCardClose(item.id);
            });
            marker.addListener('click', (event) => { navigateToAdUrl(item.url, event); });
            return rec;
        }

        function clusterRenderer() {
            return {
                render: function ({count, position}) {
                    if (AdvancedMarker) {
                        return new AdvancedMarker({
                            position: position,
                            content: makeClusterContent(count),
                            zIndex: 100000 + count,
                        });
                    }

                    // Sadece AdvancedMarkerElement hiç yüklenemezse emniyet fallback'i.
                    var size = count >= 100 ? 50 : 42;
                    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' +
                        '<circle cx="' + (size/2) + '" cy="' + (size/2) + '" r="' + ((size/2)-1) + '" fill="rgba(218,36,29,.20)"/>' +
                        '<circle cx="' + (size/2) + '" cy="' + (size/2) + '" r="' + ((size/2)-7) + '" fill="#da241d"/>' +
                        '</svg>';
                    return new google.maps.Marker({
                        position: position,
                        icon: {
                            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                            scaledSize: new google.maps.Size(size, size),
                            anchor: new google.maps.Point(size / 2, size / 2)
                        },
                        label: { text: String(count), color: '#fff', fontWeight: '700', fontSize: '13px' },
                        zIndex: 100000 + count
                    });
                }
            };
        }

        function clearMarkers() {
            clearActiveState();
            if (clusterer && typeof clusterer.clearMarkers === 'function') clusterer.clearMarkers();
            clusterer = null;
            markers.forEach(rec => {
                if (!rec || !rec.marker) return;
                detachGoogleMarker(rec.marker);
            });
            markers = [];
            markersById = {};
            hardClearMarkerDom();
        }

        function drawInitialShape() {
            shapeOverlays.forEach(o => o.setMap(null));
            shapeOverlays = [];

            var initPoly = parsePolyStringToLatLngs(cfg.initPoly);
            var initB = parseBboxStringToBounds(cfg.initBbox);
            var hasActiveFilter = false;

            var shapeOptions = {
                strokeColor: '#da241d',
                strokeOpacity: 0.85,
                strokeWeight: 3,
                fillColor: '#da241d',
                fillOpacity: 0.10,
                clickable: false,
                map: map
            };

            if (initPoly) {
                var poly = new google.maps.Polygon(Object.assign({}, shapeOptions, {paths: initPoly}));
                shapeOverlays.push(poly);
                var polyBounds = boundsFromPath(initPoly);
                if (polyBounds) map.fitBounds(polyBounds, 50);
                hasActiveFilter = true;
            } else if (initB) {
                var rect = new google.maps.Rectangle(Object.assign({}, shapeOptions, {bounds: initB}));
                shapeOverlays.push(rect);
                map.fitBounds(initB, 50);
                hasActiveFilter = true;
            }

            return hasActiveFilter;
        }

        var hasActiveFilter = drawInitialShape();

        function setMarkers(items) {
            clearMarkers();
            hideCard();

            var bounds = new google.maps.LatLngBounds();
            var hasBounds = false;
            var records = [];

            (items || []).forEach(item => {
                if (!item || String(item.id) === '0') return;
                var rec = createMarker(item);
                if (!rec) return;

                records.push(rec);
                markersById[String(item.id)] = rec;
                bounds.extend(rec.position);
                hasBounds = true;
            });

            markers = records;

            if (window.markerClusterer && window.markerClusterer.MarkerClusterer && records.length > 0) {
                clusterer = new markerClusterer.MarkerClusterer({
                    map: map,
                    markers: records.map(r => r.marker),
                    renderer: clusterRenderer(),
                    algorithmOptions: { maxZoom: 15, radius: 60 }
                });
            } else {
                records.forEach(rec => {
                    if (rec.isAdvanced) rec.marker.map = map;
                    else rec.marker.setMap(map);
                });
            }

            if (!hasActiveFilter && hasBounds) map.fitBounds(bounds, 50);
            else if (!hasActiveFilter && !hasBounds) map.setOptions(defaults);
        }

        setMarkers(data);

        function handleListItemHoverEvent(event) {
            var id = event && event.detail ? event.detail.id : null;
            scheduleListHover(id);
        }

        function handleListItemLeaveEvent(event) {
            var id = normalizeMarkerId(event && event.detail ? event.detail.id : null);
            cancelPendingListHover();

            if (!id || (activeMarkerId === id && activeMarkerSource === 'list')) {
                clearActiveState();
            }
        }

        function handleListUpdatedEvent() {
            clearActiveState();
            hardClearMarkerDom();
        }

        window.addEventListener('ad-list:item-hover', handleListItemHoverEvent);
        window.addEventListener('ad-list:item-leave', handleListItemLeaveEvent);
        window.addEventListener('ad-list:items-updated', handleListUpdatedEvent);
        mapFrameEl.addEventListener('mouseleave', function () {
            if (activeMarkerSource === 'map') clearActiveState();
        });

        function updateListedMarkers(newItems) {
            if (!newItems || !Array.isArray(newItems)) return;

            clearActiveState();

            newItems.forEach(item => {
                var id = normalizeMarkerId(item.id);
                var rec = id ? markersById[id] : null;
                if (rec && rec.marker) {
                    rec.data.on_list = true;
                    updateMarkerAppearance(rec, false);
                }
            });

            hardClearMarkerDom();
        }

        return {
            map: map,
            setMarkers: setMarkers,
            invalidate: function(){ google.maps.event.trigger(map, 'resize'); },
            updateListedMarkers: updateListedMarkers,
            clearActiveState: clearActiveState,
            hardResetActiveMarkers: function () {
                clearActiveState();
                hardClearMarkerDom();
            },
            focusMarker: function (id) {
                setActiveMarker(id, 'manual', { pan: true });
            }
        };
    }

    // -------------------------
    // 2. Overlay Scan Map (Draw)
    // -------------------------
    function initOverlayScan(sidebarApi) {
        var overlayEl = $('map-overlay');
        var overlayMapEl = $('overlay-map');
        if (!overlayEl || !overlayMapEl) return;

        var cfg = getConfig();
        var overlayMap = null;
        var currentShape = null;
        var liveShape = null;
        var liveShapeType = null;
        var vertexMarkers = [];
        var drawingMode = null;
        var drawingListeners = [];
        var polygonPoints = [];
        var rectStart = null;
        var rectBounds = null;
        var isSubmittingGeo = false;
        var rectangleSubmitTimer = null;
        var polygonAutoClosePixelDistance = 28;

        var btnDrawFree = $('btn-draw-free');
        var btnDrawRect = $('btn-draw-rect');
        var btnClose = $('mo-close');
        var btnOpenSide = $('map-open-scan');
        var btnClearSide = $('map-clear-bbox');
        var btnClearFilter = $('mo-clear-filter');
        var actionsBox = $('mo-draw-actions');
        var btnApplyDrawing = $('mo-apply-drawing');
        var btnCancelDrawing = $('mo-cancel-drawing');
        var btnUndoDrawing = $('mo-undo-drawing');
        var helpTitle = $('mo-help-title');
        var helpText = $('mo-help-text');
        var helpMeta = $('mo-help-meta');

        function checkActiveFilter() {
            var urlParams = new URLSearchParams(window.location.search);
            var hasFilter = urlParams.has('bbox') || urlParams.has('poly');

            if (btnClearSide) {
                btnClearSide.style.display = hasFilter ? 'flex' : 'none';
                btnClearSide.onclick = (e) => {
                    e.preventDefault();
                    window.location.href = buildUrlWith({}, ['bbox', 'poly']);
                };
            }

            if (btnClearFilter) {
                btnClearFilter.style.display = hasFilter ? 'inline-flex' : 'none';
                btnClearFilter.onclick = (e) => {
                    e.preventDefault();
                    window.location.href = buildUrlWith({}, ['bbox', 'poly']);
                };
            }
        }
        checkActiveFilter();

        function setHelp(title, text, meta, state) {
            if (helpTitle) helpTitle.textContent = title || i18n('map.select_area', 'Select an area on the map');
            if (helpText) helpText.textContent = text || i18n('map.help_text_short', 'Place points with free drawing or quickly select an area with a rectangle.');
            if (helpMeta) {
                helpMeta.textContent = meta || i18n('common.ready', 'Ready');
                helpMeta.classList.remove('is-ready', 'is-warning');
                if (state === 'ready') helpMeta.classList.add('is-ready');
                if (state === 'warning') helpMeta.classList.add('is-warning');
            }
        }

        function shapeOptions(extra = {}) {
            return Object.assign({
                strokeColor: '#da241d',
                strokeOpacity: 0.9,
                strokeWeight: 3,
                fillColor: '#da241d',
                fillOpacity: 0.12,
                clickable: false,
                editable: false,
                draggable: false
            }, extra);
        }

        function setButtonDisabled(btn, disabled) {
            if (!btn) return;
            btn.disabled = !!disabled;
            btn.classList.toggle('is-disabled', !!disabled);
        }

        function setActionsVisible(visible) {
            if (!actionsBox) return;
            actionsBox.classList.toggle('is-visible', !!visible);
        }

        function hasValidPolygon() {
            return polygonPoints.length >= 3;
        }

        function hasValidRectangle() {
            return !!rectBounds;
        }

        function syncActions() {
            var isPolygon = drawingMode === 'polygon';
            var isRectangle = drawingMode === 'rectangle';
            var canApply = isPolygon ? hasValidPolygon() : (isRectangle ? hasValidRectangle() : false);
            var canUndo = isPolygon ? polygonPoints.length > 0 : (isRectangle ? !!rectBounds || !!rectStart : false);

            setActionsVisible(!!drawingMode);
            setButtonDisabled(btnApplyDrawing, !canApply || isSubmittingGeo);
            setButtonDisabled(btnUndoDrawing, !canUndo || isSubmittingGeo);

            if (isPolygon) {
                if (hasValidPolygon()) {
                    setHelp(
                        i18n('map.free_area_drawing', 'Free area drawing'),
                        i18n('map.free_area_ready', 'Area is ready. Click the first point again to close it, or apply it with Search Area.'),
                        i18n('map.points_connect_first', ':count points • connect to first', { count: polygonPoints.length }),
                        'ready'
                    );
                } else {
                    var missing = Math.max(0, 3 - polygonPoints.length);
                    setHelp(
                        i18n('map.free_area_drawing', 'Free area drawing'),
                        i18n('map.free_area_help', 'Click the map to set corner points. At least 3 points are required.'),
                        polygonPoints.length
                            ? i18n('map.more_points_needed', ':count more points needed', { count: missing })
                            : i18n('map.select_first_point', 'Select the first point'),
                        polygonPoints.length ? 'warning' : ''
                    );
                }
            } else if (isRectangle) {
                if (hasValidRectangle()) {
                    setHelp(
                        i18n('map.rectangle_area_drawing', 'Rectangle area drawing'),
                        i18n('map.rectangle_ready_help', 'Selection is ready. Apply the filter with Search Area or drag again to redraw.'),
                        i18n('map.rectangle_ready', 'Rectangle selection ready'),
                        'ready'
                    );
                } else {
                    setHelp(
                        i18n('map.rectangle_area_drawing', 'Rectangle area drawing'),
                        i18n('map.rectangle_help', 'Press and drag on the map to select an area. Release to preview, then use Search Area.'),
                        i18n('map.drag_select_area', 'Drag to select an area'),
                        ''
                    );
                }
            } else {
                setHelp(
                    i18n('map.select_area', 'Select an area on the map'),
                    i18n('map.help_text_short', 'Place points with free drawing or quickly select an area with a rectangle.'),
                    i18n('common.ready', 'Ready'),
                    ''
                );
            }
        }

        function addDrawingListener(listener) {
            drawingListeners.push(listener);
            return listener;
        }

        function clearRectangleSubmitTimer() {
            if (rectangleSubmitTimer) {
                window.clearTimeout(rectangleSubmitTimer);
                rectangleSubmitTimer = null;
            }
        }

        function scheduleRectangleSubmit() {
            clearRectangleSubmitTimer();
            rectangleSubmitTimer = window.setTimeout(function () {
                if (drawingMode === 'rectangle' && hasValidRectangle() && !isSubmittingGeo) {
                    applyDrawing();
                }
            }, 380);
        }

        function clearDrawingListeners() {
            drawingListeners.forEach(listener => google.maps.event.removeListener(listener));
            drawingListeners = [];
        }

        function clearCurrentShape() {
            if (currentShape && typeof currentShape.setMap === 'function') currentShape.setMap(null);
            currentShape = null;
        }

        function clearVertexMarkers() {
            vertexMarkers.forEach(m => detachGoogleMarker(m));
            vertexMarkers = [];
        }

        function clearLiveShape() {
            if (liveShape && typeof liveShape.setMap === 'function') liveShape.setMap(null);
            liveShape = null;
            liveShapeType = null;
            clearVertexMarkers();
        }

        function clearDrawingState(options) {
            var opts = Object.assign({ keepCurrentShape: false, keepHelp: false }, options || {});

            clearDrawingListeners();
            clearRectangleSubmitTimer();
            clearLiveShape();
            polygonPoints = [];
            rectStart = null;
            rectBounds = null;
            drawingMode = null;
            isSubmittingGeo = false;
            setActionsVisible(false);

            if (!opts.keepCurrentShape) clearCurrentShape();

            if (overlayMap) {
                overlayMap.setOptions({
                    draggable: true,
                    draggableCursor: null,
                    draggingCursor: null,
                    disableDoubleClickZoom: false,
                    gestureHandling: 'greedy'
                });
            }

            if (overlayEl) overlayEl.classList.remove('is-drawing');
            if (btnDrawFree) btnDrawFree.classList.remove('is-active');
            if (btnDrawRect) btnDrawRect.classList.remove('is-active');

            if (!opts.keepHelp) syncActions();
        }

        function makeVertexMarker(position, index) {
            var AdvancedMarker = getAdvancedMarkerClass();
            var isClosable = index === 0 && hasValidPolygon();
            var marker = null;

            if (AdvancedMarker) {
                marker = new AdvancedMarker({
                    map: overlayMap,
                    position: position,
                    content: makeVertexContent(index, isClosable),
                    zIndex: 9999 + index,
                    title: isClosable ? i18n('map.close_area_and_search', 'Close area and search') : i18n('map.vertex_point', 'Drawing point')
                });
            } else {
                marker = new google.maps.Marker({
                    map: overlayMap,
                    position: position,
                    clickable: isClosable,
                    zIndex: 9999 + index,
                    title: isClosable ? i18n('map.close_area_and_search', 'Close area and search') : i18n('map.vertex_point', 'Drawing point'),
                    cursor: isClosable ? 'pointer' : 'default',
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: isClosable ? 7 : 5,
                        fillColor: isClosable ? '#111111' : '#da241d',
                        fillOpacity: 1,
                        strokeColor: '#ffffff',
                        strokeWeight: 2
                    }
                });
            }

            if (isClosable && marker && typeof marker.addListener === 'function') {
                marker.addListener('click', function () {
                    if (drawingMode === 'polygon' && hasValidPolygon() && !isSubmittingGeo) {
                        applyDrawing();
                    }
                });
            }

            return marker;
        }

        function renderVertices() {
            clearVertexMarkers();
            vertexMarkers = polygonPoints.map((point, index) => makeVertexMarker(point, index));
        }

        function setLivePath(path) {
            if (!path || path.length < 2) {
                if (liveShape && typeof liveShape.setMap === 'function') liveShape.setMap(null);
                liveShape = null;
                liveShapeType = null;
                return;
            }

            var nextType = path.length >= 3 ? 'polygon' : 'polyline';

            if (liveShape && liveShapeType !== nextType) {
                liveShape.setMap(null);
                liveShape = null;
                liveShapeType = null;
            }

            if (!liveShape) {
                if (nextType === 'polygon') {
                    liveShape = new google.maps.Polygon(shapeOptions({
                        paths: path,
                        map: overlayMap,
                        fillOpacity: 0.10
                    }));
                } else {
                    liveShape = new google.maps.Polyline({
                        path: path,
                        map: overlayMap,
                        strokeColor: '#da241d',
                        strokeOpacity: 0.95,
                        strokeWeight: 3,
                        clickable: false
                    });
                }
                liveShapeType = nextType;
                return;
            }

            if (nextType === 'polygon' && typeof liveShape.setPaths === 'function') {
                liveShape.setPaths(path);
            } else if (nextType === 'polyline' && typeof liveShape.setPath === 'function') {
                liveShape.setPath(path);
            }
        }

        function shouldAddPolygonPoint(latLng) {
            if (!latLng) return false;
            var last = polygonPoints[polygonPoints.length - 1];
            if (!last) return true;
            var a = latLngToPlain(last);
            var b = latLngToPlain(latLng);
            if (!a || !b) return true;
            return Math.abs(a.lat - b.lat) > 0.000001 || Math.abs(a.lng - b.lng) > 0.000001;
        }

        function latLngToPixelPoint(latLng) {
            if (!overlayMap || !latLng || typeof overlayMap.getProjection !== 'function') return null;
            var projection = overlayMap.getProjection();
            if (!projection || typeof projection.fromLatLngToPoint !== 'function') return null;

            var ll = latLng;
            if (!(ll instanceof google.maps.LatLng)) {
                var p = latLngToPlain(latLng);
                if (!p) return null;
                ll = new google.maps.LatLng(p.lat, p.lng);
            }

            var scale = Math.pow(2, overlayMap.getZoom() || 0);
            var point = projection.fromLatLngToPoint(ll);
            return {x: point.x * scale, y: point.y * scale};
        }

        function pixelDistanceBetweenLatLng(a, b) {
            var ap = latLngToPixelPoint(a);
            var bp = latLngToPixelPoint(b);
            if (!ap || !bp) return Infinity;
            var dx = ap.x - bp.x;
            var dy = ap.y - bp.y;
            return Math.sqrt((dx * dx) + (dy * dy));
        }

        function isClosingPolygonPoint(latLng) {
            if (!latLng || polygonPoints.length < 3) return false;
            var first = polygonPoints[0];
            return pixelDistanceBetweenLatLng(first, latLng) <= polygonAutoClosePixelDistance;
        }

        function renderPolygonPreview(cursorLatLng = null, redrawVertices = false) {
            if (redrawVertices) renderVertices();

            var path = polygonPoints.slice();
            if (cursorLatLng && polygonPoints.length > 0) path.push(cursorLatLng);

            setLivePath(path);
            syncActions();
        }

        function boundsFromTwoPoints(a, b) {
            if (!a || !b) return null;
            var aPlain = latLngToPlain(a);
            var bPlain = latLngToPlain(b);
            if (!aPlain || !bPlain) return null;

            var south = Math.min(aPlain.lat, bPlain.lat);
            var north = Math.max(aPlain.lat, bPlain.lat);
            var west = Math.min(aPlain.lng, bPlain.lng);
            var east = Math.max(aPlain.lng, bPlain.lng);

            if (Math.abs(north - south) < 0.00001 || Math.abs(east - west) < 0.00001) return null;

            return new google.maps.LatLngBounds(
                {lat: south, lng: west},
                {lat: north, lng: east}
            );
        }

        function setRectanglePreview(bounds) {
            if (!bounds) return;

            if (!liveShape || liveShapeType !== 'rectangle') {
                if (liveShape && typeof liveShape.setMap === 'function') liveShape.setMap(null);
                liveShape = new google.maps.Rectangle(Object.assign({}, shapeOptions({map: overlayMap}), {bounds: bounds}));
                liveShapeType = 'rectangle';
            } else if (typeof liveShape.setBounds === 'function') {
                liveShape.setBounds(bounds);
            }
        }

        function submitGeo(params, removeKeys) {
            if (isSubmittingGeo) return;
            isSubmittingGeo = true;
            syncActions();
            showToast('info', i18n('map.searching_title', 'Searching...'), i18n('map.searching_message', 'Listings in the selected area are being loaded.'));
            window.setTimeout(() => {
                window.location.href = buildUrlWith(params, removeKeys || []);
            }, 250);
        }

        function applyDrawing() {
            if (drawingMode === 'polygon') {
                if (!hasValidPolygon()) {
                    showToast('error', i18n('map.incomplete_drawing_title', 'Incomplete drawing'), i18n('map.need_three_points', 'Select at least 3 points to search an area.'));
                    syncActions();
                    return;
                }

                submitGeo({poly: polyStringFromLatLngs(polygonPoints)}, ['bbox']);
                return;
            }

            if (drawingMode === 'rectangle') {
                if (!hasValidRectangle()) {
                    showToast('error', i18n('map.incomplete_drawing_title', 'Incomplete drawing'), i18n('map.drag_to_select', 'Press and drag on the map to select an area.'));
                    syncActions();
                    return;
                }

                var bbox = bboxStringFromBounds(rectBounds);
                if (!bbox) {
                    showToast('error', i18n('map.invalid_drawing_title', 'Invalid drawing'), i18n('map.invalid_drawing_message', 'The selected area could not be read. Please draw it again.'));
                    return;
                }

                submitGeo({bbox: bbox}, ['poly']);
            }
        }

        function undoDrawing() {
            if (drawingMode === 'polygon') {
                polygonPoints.pop();
                renderPolygonPreview(null, true);
                return;
            }

            if (drawingMode === 'rectangle') {
                clearRectangleSubmitTimer();
                rectStart = null;
                rectBounds = null;
                clearLiveShape();
                syncActions();
            }
        }

        function fitExistingGeometry() {
            var initPoly = parsePolyStringToLatLngs(cfg.initPoly);
            var initB = parseBboxStringToBounds(cfg.initBbox);
            var opts = shapeOptions({clickable: false});

            clearCurrentShape();

            if (initPoly) {
                currentShape = new google.maps.Polygon(Object.assign({}, opts, {paths: initPoly, map: overlayMap}));
                var b = boundsFromPath(initPoly);
                if (b) overlayMap.fitBounds(b, 40);
                setHelp(i18n('map.current_drawing_filter', 'Current drawing filter'), i18n('map.current_free_filter_help', 'A free-draw filter is active. Choose a tool above to draw a new area.'), i18n('map.active_filter', 'Filter active'), 'ready');
                return true;
            }

            if (initB) {
                currentShape = new google.maps.Rectangle(Object.assign({}, opts, {bounds: initB, map: overlayMap}));
                overlayMap.fitBounds(initB, 40);
                setHelp(i18n('map.current_drawing_filter', 'Current drawing filter'), i18n('map.current_rectangle_filter_help', 'A rectangle filter is active. Choose a tool above to draw a new area.'), i18n('map.active_filter', 'Filter active'), 'ready');
                return true;
            }

            syncActions();
            return false;
        }

        function ensureOverlayMap(autoStartMode) {
            if (!isGoogleMapsReady()) {
                showToast('error', i18n('map.unavailable_title', 'Map unavailable'), i18n('map.unavailable_config_message', 'Check the Google Maps API key, Map ID, and marker library.'));
                showMapUnavailable(i18n('map.unavailable_config_short', 'Google Maps could not be loaded. Check the API key / Map ID.'));
                return;
            }

            if (overlayMap) {
                window.setTimeout(() => {
                    google.maps.event.trigger(overlayMap, 'resize');
                    if (autoStartMode) startDrawing(autoStartMode);
                    else fitExistingGeometry();
                }, 120);
                return;
            }

            var defaults = centerFromConfig();
            overlayMap = new google.maps.Map(overlayMapEl, getGoogleMapOptions({
                center: sidebarApi && sidebarApi.map ? sidebarApi.map.getCenter() : defaults.center,
                zoom: sidebarApi && sidebarApi.map ? sidebarApi.map.getZoom() : defaults.zoom,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                gestureHandling: 'greedy',
                clickableIcons: false,
                streetViewControl: true,
                fullscreenControl: true,
                scaleControl: true,
                zoomControl: true,
                zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
                streetViewControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER },
                fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP },
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: google.maps.ControlPosition.TOP_RIGHT,
                    mapTypeIds: [
                        google.maps.MapTypeId.ROADMAP,
                        google.maps.MapTypeId.SATELLITE,
                        google.maps.MapTypeId.HYBRID,
                        google.maps.MapTypeId.TERRAIN
                    ]
                }
            }));

            fitExistingGeometry();

            if (autoStartMode) {
                window.setTimeout(() => startDrawing(autoStartMode), 180);
            }
        }

        function startDrawing(type) {
            if (!overlayMap) return;

            clearDrawingState({ keepHelp: true });
            clearCurrentShape();
            drawingMode = type;
            overlayEl.classList.add('is-drawing');

            if (btnDrawFree) btnDrawFree.classList.toggle('is-active', type === 'polygon');
            if (btnDrawRect) btnDrawRect.classList.toggle('is-active', type === 'rectangle');

            overlayMap.setOptions({
                draggable: type === 'polygon',
                draggableCursor: 'crosshair',
                draggingCursor: type === 'rectangle' ? 'crosshair' : null,
                disableDoubleClickZoom: true,
                clickableIcons: false,
                gestureHandling: 'greedy'
            });

            if (type === 'polygon') {
                showToast('info', i18n('map.free_draw', 'Free drawing'), i18n('map.free_draw_toast', 'Select points. Click the first point again to close the shape; search will start automatically.'));

                addDrawingListener(overlayMap.addListener('click', function (e) {
                    if (!e.latLng || isSubmittingGeo) return;

                    if (isClosingPolygonPoint(e.latLng)) {
                        applyDrawing();
                        return;
                    }

                    if (!shouldAddPolygonPoint(e.latLng)) return;
                    polygonPoints.push(e.latLng);
                    renderPolygonPreview(null, true);
                }));

                addDrawingListener(overlayMap.addListener('mousemove', function (e) {
                    if (!e.latLng || polygonPoints.length === 0 || isSubmittingGeo) return;
                    renderPolygonPreview(e.latLng, false);

                    if (isClosingPolygonPoint(e.latLng)) {
                        setHelp(
                            i18n('map.free_area_drawing', 'Free area drawing'),
                            i18n('map.click_first_to_search', 'Click the first point to close the area and start the search.'),
                            i18n('map.points_ready_to_close', ':count points • ready to close', { count: polygonPoints.length }),
                            'ready'
                        );
                    }
                }));

                addDrawingListener(overlayMap.addListener('rightclick', function () {
                    undoDrawing();
                }));

                addDrawingListener(overlayMap.addListener('dblclick', function (e) {
                    if (e.domEvent) {
                        e.domEvent.preventDefault();
                        e.domEvent.stopPropagation();
                    }
                    if (hasValidPolygon()) applyDrawing();
                }));
            } else {
                showToast('info', i18n('map.rectangle_draw', 'Rectangle drawing'), i18n('map.rectangle_draw_toast', 'Press and drag. Search starts in the selected area when you release.'));

                addDrawingListener(overlayMap.addListener('mousedown', function (e) {
                    if (!e.latLng || isSubmittingGeo) return;
                    clearRectangleSubmitTimer();
                    rectStart = e.latLng;
                    rectBounds = null;
                    if (liveShape && typeof liveShape.setMap === 'function') liveShape.setMap(null);
                    liveShape = null;
                    liveShapeType = null;
                    syncActions();
                }));

                addDrawingListener(overlayMap.addListener('mousemove', function (e) {
                    if (!rectStart || !e.latLng || isSubmittingGeo) return;
                    var bounds = boundsFromTwoPoints(rectStart, e.latLng);
                    if (!bounds) return;
                    setRectanglePreview(bounds);
                }));

                addDrawingListener(overlayMap.addListener('mouseup', function (e) {
                    if (!rectStart || !e.latLng || isSubmittingGeo) return;
                    var bounds = boundsFromTwoPoints(rectStart, e.latLng);
                    rectStart = null;

                    if (!bounds) {
                        rectBounds = null;
                        clearLiveShape();
                        showToast('error', i18n('map.area_too_small_title', 'Area too small'), i18n('map.area_too_small_message', 'Please select a larger area.'));
                        syncActions();
                        return;
                    }

                    rectBounds = bounds;
                    setRectanglePreview(rectBounds);
                    syncActions();
                    scheduleRectangleSubmit();
                }));
            }

            syncActions();
        }

        function openOverlay(mode) {
            overlayEl.classList.add('is-open');
            document.body.classList.add('is-map-overlay-open');
            overlayEl.setAttribute('aria-hidden', 'false');
            ensureOverlayMap(mode);
        }

        function closeOverlay() {
            overlayEl.classList.remove('is-open');
            document.body.classList.remove('is-map-overlay-open');
            overlayEl.setAttribute('aria-hidden', 'true');
            clearDrawingState({ keepCurrentShape: true });
            if (overlayMap) fitExistingGeometry();
        }

        if (btnDrawFree) btnDrawFree.onclick = (e) => { e.preventDefault(); e.stopPropagation(); ensureOverlayMap(); startDrawing('polygon'); };
        if (btnDrawRect) btnDrawRect.onclick = (e) => { e.preventDefault(); e.stopPropagation(); ensureOverlayMap(); startDrawing('rectangle'); };
        if (btnApplyDrawing) btnApplyDrawing.onclick = (e) => { e.preventDefault(); applyDrawing(); };
        if (btnUndoDrawing) btnUndoDrawing.onclick = (e) => { e.preventDefault(); undoDrawing(); };
        if (btnCancelDrawing) btnCancelDrawing.onclick = (e) => { e.preventDefault(); clearDrawingState(); if (overlayMap) fitExistingGeometry(); };

        if (btnOpenSide) btnOpenSide.onclick = (e) => {
            e.preventDefault();
            openOverlay('polygon');
        };

        if (btnClose) btnClose.onclick = closeOverlay;

        document.addEventListener('keydown', function (e) {
            if (!overlayEl.classList.contains('is-open')) return;

            if (e.key === 'Escape') {
                e.preventDefault();
                closeOverlay();
                return;
            }

            if ((e.key === 'Backspace' || e.key === 'Delete') && drawingMode) {
                e.preventDefault();
                undoDrawing();
                return;
            }

            if (e.key === 'Enter' && drawingMode) {
                e.preventDefault();
                applyDrawing();
            }
        });

        syncActions();
    }

    // -------------------------
    // Saved Search Thumbs (Canvas)
    // -------------------------
    function getThumbPoints(max) {
        var cfg = getConfig();
        var arr = Array.isArray(cfg.mapPoints) ? cfg.mapPoints : [];
        return arr.filter(p => p && String(p.id) !== '0' && isFinite(p.lat) && isFinite(p.lng)).slice(0, max || 150).map(p => ({lat: parseFloat(p.lat), lng: parseFloat(p.lng)}));
    }

    function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

    async function buildSavedSearchThumbBase64(w, h) {
        var cfg = getConfig();
        var g = {
            bbox: (new URL(window.location.href)).searchParams.get('bbox'),
            poly: (new URL(window.location.href)).searchParams.get('poly')
        };

        var polyPoints = parsePolyStringRaw(g.poly);
        var bboxRaw = parseBboxStringRaw(g.bbox);
        var points = getThumbPoints(180);

        var all = [];
        points.forEach(p => all.push(p));
        if (polyPoints) polyPoints.forEach(p => all.push(p));
        if (bboxRaw) {
            all.push({lat: bboxRaw.south, lng: bboxRaw.west});
            all.push({lat: bboxRaw.north, lng: bboxRaw.east});
        }

        if (!all.length) {
            var center = cfg.defaultCenter || [40.2330916, 28.9824323];
            all = [{lat: parseFloat(center[0]) || 40.2330916, lng: parseFloat(center[1]) || 28.9824323}];
        }

        var south = Math.min(...all.map(p => p.lat));
        var north = Math.max(...all.map(p => p.lat));
        var west  = Math.min(...all.map(p => p.lng));
        var east  = Math.max(...all.map(p => p.lng));

        var latPad = Math.max((north - south) * 0.18, 0.01);
        var lngPad = Math.max((east - west) * 0.18, 0.01);
        south -= latPad; north += latPad; west -= lngPad; east += lngPad;

        function project(p) {
            var x = ((p.lng - west) / Math.max(east - west, 0.000001)) * w;
            var y = ((north - p.lat) / Math.max(north - south, 0.000001)) * h;
            return {x, y};
        }

        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');

        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, w, h);

        ctx.strokeStyle = 'rgba(0,0,0,0.045)';
        ctx.lineWidth = 1;
        for (let x = 0; x <= w; x += Math.max(40, w / 7)) {
            ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke();
        }
        for (let y = 0; y <= h; y += Math.max(34, h / 6)) {
            ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke();
        }

        if (polyPoints) {
            ctx.fillStyle = 'rgba(218,36,29,0.12)';
            ctx.strokeStyle = 'rgba(218,36,29,0.95)';
            ctx.lineWidth = 3;
            ctx.beginPath();
            polyPoints.forEach((p, i) => {
                var pt = project(p);
                if (i === 0) ctx.moveTo(pt.x, pt.y);
                else ctx.lineTo(pt.x, pt.y);
            });
            ctx.closePath(); ctx.fill(); ctx.stroke();
        } else if (bboxRaw) {
            var sw = project({lat: bboxRaw.south, lng: bboxRaw.west});
            var ne = project({lat: bboxRaw.north, lng: bboxRaw.east});
            var rx = Math.min(sw.x, ne.x), ry = Math.min(sw.y, ne.y);
            var rw = Math.abs(sw.x - ne.x), rh = Math.abs(sw.y - ne.y);
            ctx.fillStyle = 'rgba(218,36,29,0.10)';
            ctx.strokeStyle = 'rgba(218,36,29,0.95)';
            ctx.lineWidth = 3;
            ctx.fillRect(rx, ry, rw, rh);
            ctx.strokeRect(rx, ry, rw, rh);
        }

        if (points.length) {
            ctx.fillStyle = 'rgba(218,36,29,0.9)';
            ctx.strokeStyle = '#fff';
            ctx.lineWidth = 1.5;
            points.forEach(p => {
                var pt = project(p);
                if(pt.x>-10 && pt.x<w+10 && pt.y>-10 && pt.y<h+10) {
                    ctx.beginPath(); ctx.arc(pt.x, pt.y, 3.5, 0, Math.PI*2); ctx.fill(); ctx.stroke();
                }
            });
        }

        ctx.fillStyle = 'rgba(17,17,17,0.72)';
        ctx.font = '700 13px sans-serif';
        ctx.fillText(i18n('map.export_stamp', 'Home.com.tr Map Search'), 16, h - 18);

        return canvas.toDataURL('image/jpeg', 0.82);
    }

    function currentQueryString() {
        var form = $('listFilterForm');
        if (!form) return window.location.search;
        var sp = new URLSearchParams(new FormData(form));
        sp.delete('page');
        sp.delete('include_map');

        Array.from(new Set(Array.from(sp.keys()))).forEach(function (key) {
            var values = sp.getAll(key).map(function (value) {
                return String(value || '').trim();
            }).filter(function (value) {
                return value !== '';
            });

            sp.delete(key);
            values.forEach(function (value) {
                sp.append(key, value);
            });
        });

        return '?' + sp.toString();
    }

    function currentTotalResults() {
        var cfg = getConfig();
        var total = Number(cfg.totalResults || 0);
        return Number.isFinite(total) ? total : 0;
    }

    async function submitSaveSearch() {
        var cfg = getConfig();
        var url = cfg.savedSearchStoreUrl;
        if (!url) return showToast('error', i18n('common.error', 'Error'), i18n('saved_search.store_url_missing', 'Save URL was not found.'));
        if (!requireFrontAuth(cfg.loginUrl, { redirect: false })) return;

        var totalResults = currentTotalResults();
        if (totalResults <= 0) {
            return showToast('info', i18n('saved_search.no_results_title', 'No results'), i18n('saved_search.no_results_message', 'Searches with no listing results are not saved.'));
        }

        var name = $('savedSearchName').value.trim();
        var preview = buildRecentSearchMapPreview();
        var thumb = await buildSavedSearchThumbBase64(640, 360);

        try {
            var res = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrfToken() },
                body: JSON.stringify({
                    name: name,
                    query_string: currentQueryString(),
                    thumb_base64: thumb,
                    total_results: totalResults,
                    map_preview: preview
                })
            });
            if (res.status === 401) {
                requireFrontAuth(cfg.loginUrl, { redirect: false });
                return;
            }
            if (res.ok) {
                showToast('success', i18n('saved_search.saved_title', 'Saved'), i18n('saved_search.saved_message', 'Search saved successfully.'));
                document.querySelectorAll('[data-fancybox-close]').forEach(b => b.click());
            } else {
                let err = null;
                try { err = await res.json(); } catch (e) {}
                showToast('error', i18n('common.error', 'Error'), err?.message || i18n('common.operation_failed', 'Operation failed.'));
            }
        } catch(e) { showToast('error', i18n('common.error', 'Error'), i18n('common.connection_failed_short', 'Connection error.')); }
    }

    const RECENT_SEARCH_SKIP_KEYS = new Set([
        'page',
        'bbox',
        'poly',
        'country_id',
        'city_id',
        'district_id',
        'quarter_id',
        'transaction_type',
        'category_id',
        'main_category_id',
        'subcategory_id',
        'min_price',
        'max_price',
        'price_min',
        'price_max',
        'm2_min',
        'm2_max',
        'q',
        'sort',
        'view',
        'include_map'
    ]);

    function selectedOptionText(selectEl) {
        if (!selectEl || !selectEl.value) return '';
        const opt = selectEl.options[selectEl.selectedIndex];
        return opt ? String(opt.textContent || '').trim() : '';
    }

    function cleanText(v) {
        return String(v || '').replace(/\s+/g, ' ').trim();
    }

    function uniqueStrings(arr = []) {
        return [...new Set((arr || []).map(cleanText).filter(Boolean))];
    }

    function getUrlParam(name) {
        try {
            return cleanText(new URL(window.location.href).searchParams.get(name) || '');
        } catch (e) {
            return '';
        }
    }

    function buildLocationLabel() {
        const cfg = getConfig();
        const labels = cfg.currentLocationLabels || {};

        const city =
            selectedOptionText($('adlistSfCity')) ||
            labels.city ||
            '';

        const dist =
            selectedOptionText($('adlistSfDistrict')) ||
            labels.district ||
            '';

        const neigh =
            selectedOptionText($('adlistSfNeighborhood')) ||
            labels.neighborhood ||
            '';

        return [city, dist, neigh].filter(Boolean).join(', ');
    }

    function buildLocationTag() {
        const loc = buildLocationLabel();
        return loc ? i18n('recent.location_prefix', 'Location: :location', { location: loc }) : '';
    }

    function buildKeywordTag() {
        const q = getUrlParam('q');
        return q ? `${i18n('recent.search_prefix', 'Search')}: ${q}` : '';
    }

    function buildRangeTag(label, minVal, maxVal, suffix = '') {
        const min = cleanText(minVal);
        const max = cleanText(maxVal);

        if (!min && !max) return '';

        if (min && max) {
            return `${label}: ${min} - ${max}${suffix ? ' ' + suffix : ''}`;
        }

        if (min) {
            return `${label}: ${min}+${suffix ? ' ' + suffix : ''}`;
        }

        return `${label}: 0 - ${max}${suffix ? ' ' + suffix : ''}`;
    }

    function buildPriceTag() {
        return buildRangeTag(
            i18n('price.label', 'Price'),
            formValue('min_price') || formValue('price_min'),
            formValue('max_price') || formValue('price_max'),
            'TL'
        );
    }

    function buildAreaTag() {
        return buildRangeTag(
            i18n('area.label', 'Area'),
            formValue('m2_min'),
            formValue('m2_max'),
            'm²'
        );
    }

    function buildCategoryLabel() {
        const maps = buildMapsFromDict();
        const catId = formValue('category_id');
        if (!catId || ['all', '0', '*'].includes(String(catId).toLowerCase())) return i18n('category.all_listings', 'All Listings');
        return maps.catMap[String(catId)] || i18n('category.listings', 'Listings');
    }

    function buildTransactionLabel() {
        return formValue('transaction_type') === '2' ? i18n('transaction.rent', 'For Rent') : i18n('transaction.sale', 'For Sale');
    }

    function buildSearchCardTitle() {
        const tx = buildTransactionLabel();
        const cat = buildCategoryLabel();
        return `${tx} ${cat}`;
    }

    function safeSelectorName(name) {
        return String(name || '')
            .replace(/\\/g, '\\\\')
            .replace(/"/g, '\\"');
    }

    function getNamedInputs(name) {
        const safeName = safeSelectorName(name);
        return Array.from(document.querySelectorAll(
            `#adlist-search-filter-popup [name="${safeName}"], #listFilterForm [name="${safeName}"]`
        ));
    }

    function getInputLabel(input, name) {
        if (!input) return humanizeFilterName(name);

        const filterBoxItem = input.closest('.filter-box-item');
        const filterTitle = filterBoxItem?.querySelector('.fbr-title');
        if (filterTitle) {
            return cleanText(filterTitle.textContent);
        }

        const pageFilterItem = input.closest('.page-filter-item');
        const pageFilterLabel = pageFilterItem?.querySelector('.filter-toggle-icon small');
        if (pageFilterLabel) {
            return cleanText(pageFilterLabel.textContent);
        }

        const label = input.closest('label');
        if (label) {
            const small = label.querySelector('small');
            if (small) return cleanText(small.textContent);
            return cleanText(label.textContent);
        }

        return humanizeFilterName(name);
    }

    function humanizeFilterName(name) {
        return String(name || '')
            .replace(/\[\]/g, '')
            .replace(/\[/g, ' ')
            .replace(/\]/g, ' ')
            .replace(/_/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/\b\w/g, c => c.toUpperCase());
    }

    function getInputDisplayValues(inputs = []) {
        const values = [];

        inputs.forEach((input) => {
            if (!input || input.type === 'hidden' || input.disabled) return;

            if (input.type === 'radio' || input.type === 'checkbox') {
                if (!input.checked) return;

                const label = input.closest('label');
                const small = label?.querySelector('small');
                const text = small ? cleanText(small.textContent) : cleanText(label?.textContent || input.value);
                if (text) values.push(text);
                return;
            }

            if (input.tagName === 'SELECT') {
                const text = selectedOptionText(input);
                if (text) values.push(text);
                return;
            }

            const val = cleanText(input.value);
            if (val) values.push(val);
        });

        return uniqueStrings(values);
    }

    function buildDynamicFeatureTags(limit = 3) {
        const names = new Set();

        document.querySelectorAll('#adlist-search-filter-popup [name], #listFilterForm [name]').forEach((el) => {
            const name = cleanText(el.getAttribute('name'));
            if (!name) return;
            if (RECENT_SEARCH_SKIP_KEYS.has(name)) return;
            names.add(name);
        });

        const out = [];

        Array.from(names).forEach((name) => {
            if (out.length >= limit) return;

            const inputs = getNamedInputs(name).filter(el => el.type !== 'hidden');
            if (!inputs.length) return;

            const values = getInputDisplayValues(inputs);
            if (!values.length) return;

            const label = getInputLabel(inputs[0], name);
            const tag = label
                ? `${label}: ${values.join(', ')}`
                : values.join(', ');

            if (tag) out.push(tag);
        });

        return uniqueStrings(out).slice(0, limit);
    }

    function buildRecentSearchTags() {
        return uniqueStrings([
            buildLocationTag(),
            buildKeywordTag(),
            buildPriceTag(),
            buildAreaTag(),
            ...buildDynamicFeatureTags(3),
        ]).slice(0, 8);
    }

    function locationSelectsReady() {
        const cityId = formValue('city_id');
        const distId = formValue('district_id');
        const neighId = formValue('quarter_id');

        const cityReady  = !cityId  || (($('adlistSfCity') || {}).options || []).length > 1;
        const distReady  = !distId  || (($('adlistSfDistrict') || {}).options || []).length > 1;
        const neighReady = !neighId || (($('adlistSfNeighborhood') || {}).options || []).length > 1;

        return cityReady && distReady && neighReady;
    }

    function paramsObjectFromCurrentUrl() {
        const out = {};

        try {
            const url = new URL(window.location.href);
            url.searchParams.forEach((value, key) => {
                if (!key || key === 'page' || key === 'include_map') return;

                if (out[key] === undefined) {
                    out[key] = value;
                    return;
                }

                if (!Array.isArray(out[key])) {
                    out[key] = [out[key]];
                }

                out[key].push(value);
            });
        } catch (e) {
            return out;
        }

        return out;
    }

    function buildRecentSearchMapPreview() {
        const cfg = getConfig();
        const url = new URL(window.location.href);
        const locationLabel = buildLocationLabel() || getUrlParam('location_label');
        const defaultCenter = Array.isArray(cfg.defaultCenter) && cfg.defaultCenter.length >= 2
            ? [parseFloat(cfg.defaultCenter[0]) || 40.2330916, parseFloat(cfg.defaultCenter[1]) || 28.9824323]
            : [40.2330916, 28.9824323];

        return {
            version: 2,
            provider: 'carto-light',
            bbox: cleanText(url.searchParams.get('bbox') || ''),
            poly: cleanText(url.searchParams.get('poly') || ''),
            lat: cleanText(url.searchParams.get('lat') || ''),
            lng: cleanText(url.searchParams.get('lng') || ''),
            radius: cleanText(url.searchParams.get('radius') || ''),
            radius_label: cleanText(url.searchParams.get('radius_label') || ''),
            location_label: locationLabel,
            points: getThumbPoints(140),
            default_center: defaultCenter,
            default_zoom: parseInt(cfg.defaultZoom || 12, 10) || 12,
            total_results: currentTotalResults(),
            generated_at: Date.now(),
        };
    }

    // Recent Search Tracking
    function trackRecentSearchLightweight(attempt = 0) {
        /*
         * Eski kontrol sadece Türkçe /ilan/ara route'unda çalışıyordu.
         * Lokalize route'larda (en/fr/de/ru/...) recent-search ve poly/bbox önizlemesi
         * hiç kaydedilmiyordu. Sayfayı route metninden değil gerçek liste formundan tanıyoruz.
         */
        if (getConfig().mode === 'agency_detail') return;
        if (!$('listFilterForm')) return;

        const url = new URL(window.location.href);
        if ([...url.searchParams.keys()].filter(k => k !== 'page' && k !== 'include_map').length === 0) return;

        if (!locationSelectsReady() && attempt < 8) {
            setTimeout(() => trackRecentSearchLightweight(attempt + 1), 250);
            return;
        }

        const preview = buildRecentSearchMapPreview();

        if (Number(preview.total_results || 0) <= 0) {
            upsertRecentSearch({
                type: 'search',
                source: 'ad-list',
                href: window.location.pathname + window.location.search,
                url: window.location.pathname + window.location.search,
                map_preview: preview,
                total_results: 0,
                params: paramsObjectFromCurrentUrl(),
            });
            return;
        }

        const href = window.location.pathname + window.location.search;
        const params = paramsObjectFromCurrentUrl();

        upsertRecentSearch({
            type: 'search',
            source: 'ad-list',
            href: href,
            url: href,
            title: buildSearchCardTitle(),
            thumb_kind: 'map',
            map_preview: preview,
            params: params,
            filters: params,
            search: params,
            total_results: preview.total_results,
            location_label: preview.location_label,
            tags: buildRecentSearchTags(),
            dynamic_tags: buildDynamicFeatureTags(3),
            locale: String(document.documentElement.lang || '').trim(),
        });
    }

    // -------------------------
    // BOOT
    // -------------------------
    function boot() {
        if (getConfig().mode === 'agency_detail') {
            return;
        }

        var form = $('listFilterForm');
        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                if (window.AD_LIST_VUE_FETCH) window.AD_LIST_VUE_FETCH(Object.fromEntries(new FormData(form)));
            });
        }
        document.querySelectorAll('.js-submit-filter').forEach(btn => {
            btn.addEventListener('click', (e) => { e.preventDefault(); if (form) form.dispatchEvent(new Event('submit')); });
        });

        initAllFiltersPopup();
        updateTopLabelsAndCount();
        trackRecentSearchLightweight();

        function initPriceFormatters() {
            document.querySelectorAll('input[name="min_price"], input[name="max_price"]').forEach(function (input) {
                input.setAttribute('type', 'text');
                input.setAttribute('inputmode', 'numeric');

                const formatVal = (val) => {
                    let v = String(val).replace(/\D/g, '');
                    return v ? v.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '';
                };

                // Sayfa ilk yüklendiğinde URL'den gelen değeri formatla
                if (input.value) {
                    input.value = formatVal(input.value);
                }

                // Yazarken anında formatla
                input.addEventListener('input', function (e) {
                    e.target.value = formatVal(e.target.value);
                });
            });
        }
        initPriceFormatters();
        waitForGoogleMaps().then((ready) => {
            if (!ready) {
                showMapUnavailable(i18n('map.unavailable_key_message', 'Google Maps could not be loaded. Check GOOGLE_MAPS_API_KEY / GOOGLE_MAPS_BROWSER_KEY.'));
                return;
            }

            var sidebarApi = initSidebarMap();
            window.__ADLIST_SIDEMAP__ = sidebarApi;
            initOverlayScan(sidebarApi);
        });

        document.addEventListener('click', function(e) {
            var guestSensitiveBtn = e.target.closest('.js-open-list-msg, .js-open-fav-list, .js-open-list-appointment, #btn-open-save-search, [data-auth-required]');
            if (!guestSensitiveBtn) return;
            if (frontIsAuthed()) return;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

            requireFrontAuth(guestSensitiveBtn.getAttribute('data-login-url'), {
                redirect: false,
                title: i18n('auth.required_title', 'Sign in required'),
                message: i18n('auth.required_message', 'Sign in or create an account to perform this action.')
            });
        }, true);

        var btnSave = $('btnSaveSearchSubmit');
        if (btnSave) btnSave.onclick = (e) => { e.preventDefault(); submitSaveSearch(); };
    }

    document.addEventListener('DOMContentLoaded', boot);

})();
